import React from "react";
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';
import aboutImage from '../assets/travel-services.png';
import AboutMission from '../components/AboutMission';
import AboutServices from '../components/AboutServices';
import AboutApproach from '../components/AboutApproach';

const AboutUs = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <motion.div 
              className="text-left"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <motion.h1 
                className="text-4xl md:text-5xl lg:text-5xl font-inter font-bold text-acBlack leading-tight"
                initial={{ opacity: 0, y: 20 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 1, delay: 0.3 }}
              >
                About Validate Systems <br /><span className="text-2xl font-semibold">Documentation & Administrative Support</span>
              </motion.h1>
              
              <motion.p 
                className="text-lg text-gray-600 mt-6 max-w-2xl"
                initial={{ opacity: 0, y: 20 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 1, delay: 0.5 }}
              >
                Validate Systems provides structured documentation and administrative support services designed to help individuals and organizations manage important records with clarity, accuracy, and confidence. We simplify documentation-heavy processes by combining careful review, organized workflows, and practical guidance.
              </motion.p>

              <motion.p 
                className="text-sm text-gray-500 mt-4 max-w-2xl italic"
                initial={{ opacity: 0, y: 20 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 1, delay: 0.6 }}
              >
                Where required, we also offer limited verification support to help confirm information and reduce uncertainty—but always as a complement to strong documentation practices.
              </motion.p>
              
              <motion.div 
                className="mt-8 flex flex-col sm:flex-row items-start gap-4"
                initial={{ opacity: 0, scale: 0.8 }} 
                animate={{ opacity: 1, scale: 1 }} 
                transition={{ duration: 0.6, delay: 0.8 }}
              >
                <Link 
                  to="/contact" 
                  className="bg-acYellow hover:bg-green-700 text-white font-semibold px-8 py-3 rounded-lg transition-colors"
                >
                  Get Started
                </Link>
              </motion.div>
            </motion.div>

            {/* Right Image */}
            <motion.div 
              className="relative"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              <img
                src={aboutImage}
                alt="About Validate Systems"
                className="w-full h-auto"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Additional Sections */}
      <AboutMission />
      <AboutServices />
      <AboutApproach />
    </div>
  );
};

export default AboutUs;

